import { Injectable } from '@angular/core';
import { CustomerWaitingListViewModel } from '../business-entities/customer-waiting-list-view-model';
import { CustomerWaitingRequestModel } from '../business-entities/customer-waiting-request-model';
import { GenericResponse } from '../business-entities/generic-response';
import { CustomerWaitinglistService } from '../data-services/customer-waitinglist.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerWaitingListService {
  filterTypeId: number = 0;
  dealerId:string = '';
  customerWaitingList: CustomerWaitingListViewModel[];
  workorderstatuslistRequest:CustomerWaitingRequestModel = {
    sortColumn: '',
    sortDirection: '',
    StartRecordNumber: 0,
    DealerId: '',
    BookingDate: '',
    PageSize: 0,
    LanguageCode: '',
    AppointmentStatusId: 0,
    WorkOrderStatusId: 0,
    SearchTerm: '',
    IsForDocuments: true,
    UserId: '',
    CreatedDate: new Date(),
  };
  constructor(private service : CustomerWaitinglistService) { }

async getCustomerWaitingList(data):Promise<any>{
  await this.service.getCustomerWaitingList(data).then(
    (res:GenericResponse<Array<CustomerWaitingListViewModel>>)=>{
      this.customerWaitingList = res.responseObject;
    }
  );
  return this.customerWaitingList;
}

}
